const CATEGORIES = {
    PROGRAMMING_TECH: 10
};

const SUB_CATEGORIES = {
    VOICE_OVERS: 16,
    SOCIAL_MARKETING: 67,
    ONLINE_TUTORING: 77,
    ASTROLOGY_AND_PSYCHICS: 78,
    SPIRITUAL_AND_HEALING: 79,
    BUY_VIDEO_TESTIMONIALS: 101,
    RESUMES_COVER_LETTERS: 112,
    PROOFREADING: 114,
    WEB_MOBILE_DESIGN: 151,
    RESEARCH_AND_SUMMARIES: 169,
    WHITEBOARD_EXPLAINER_VIDEOS: 228,
    UNBOXING_VIDEOS: 427,
    CRYPTOCURRENCY: 464,
    NFT_ART: 480,
    NFT_DEVELOPMENT: 483,
    NFT_ANIMATION: 484
};

const NESTED_SUB_CATEGORIES = {
    SEO_ON_PAGE_SEO: 2153,
    SEO_TECHNICAL_SEO: 2154,
    SEO_OFF_PAGE_SEO: 2155,
    SEO_VOICE_SEARCH_SEO: 2300,
    CALL_CENTER_AND_CALLING: 2347,
    SEO_FULL_SEO_PACKAGE: 2394
};

module.exports = {
    CATEGORIES,
    SUB_CATEGORIES,
    NESTED_SUB_CATEGORIES
};
